export function isElement(node?: Node): node is Element {
  if (node && "querySelector" in node) {
    return true;
  }
  return false;
}

export function hasAnyContent(element: Element | null, selector: string | string[]) {
  if (!element) {
    return false;
  }
  if (typeof selector === "string") {
    selector = [selector];
  }
  return selector.some((s) => !!element.querySelector(s));
}

export function removeMultipleTags(content: string | undefined | null, ...tagNames: string[]) {
  return tagNames.reduce((acc, tagName) => removeTags(acc, tagName), content);
}

export function removeTags(content: string | undefined | null, tagName: string) {
  return content?.replace(new RegExp(`(<${tagName}[^>]+?>|<${tagName}>|</${tagName}>)`, "gim"), " ");
}

export const removePTags = (content: string | undefined | null) => removeTags(content, "p");
export const removeDivTags = (content: string | undefined | null) => removeTags(content, "div");
export const removeSpanTags = (content: string | undefined | null) => removeTags(content, "span");
